import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Agreement } from '@availity/typography';
import ReactMarkdown from 'react-markdown';
import { useSpaces } from './Spaces';

var SpacesAgreement = function SpacesAgreement(_ref) {
  var spaceId = _ref.spaceId,
      markdown = _ref.markdown,
      props = _objectWithoutPropertiesLoose(_ref, ["spaceId", "markdown"]);

  var _useSpaces = useSpaces(spaceId),
      _useSpaces$ = _useSpaces[0],
      space = _useSpaces$ === void 0 ? {} : _useSpaces$;

  var agreement = space.description;

  if (agreement) {
    var children = markdown ? React.createElement(ReactMarkdown, {
      source: agreement
    }) : agreement;
    return React.createElement(Agreement, Object.assign({
      "data-testid": "spaces-agreement-" + (spaceId || space.id)
    }, props), children);
  }

  return null;
};

SpacesAgreement.defaultProps = {
  markdown: false
};
export default SpacesAgreement;